import { ID, IntlMessage } from "../Intl";

export function flight(value: string | null): IntlMessage | undefined {
  const regexp = new RegExp(/^[0-9a-zA-Za-zA-Z\u0400-\u0481\u048A-\u04FF][0-9a-zA-Z\u0400-\u0481\u048A-\u04FF][0-9]{2,5}/);
  return value && !regexp.test(value) ? ID("valid.flight") : undefined;
}
